// extracted by mini-css-extract-plugin
export default {"Project":"Project_Project__t9UV3","Project__showcase":"Project_Project__showcase__rw2SD"};